<template>
    <div>
        <h2>Chiffre d'affaires</h2>
        <input type="text" class="result blue1" disabled :value="chartDatas.total_ca">
        
        <h2 v-if="page==2">Nombre global de participations</h2>
        <input v-if="page==2" type="text" class="result blue2" disabled :value="chartDatas.total_participants">

        <h2>Nombre de participations traitées valides</h2>
        <input type="text" class="result blue3" disabled :value="chartDatas.participations_valide">

    </div>
</template>
<script>

  export default {
    props: {
        page : { type : [Number, String] },
        chartDatas: { type: Object, required: false, default: function () { return {} }},
    }
  }
</script>

<style lang="scss">
    .result {
        text-align: center;
        color:white;
        font-size: 20px;
       }
</style>

